/**
 * Do not edit directly, this file was auto-generated.
 */

export const BuiTokenBorderColorDefault = "#D3DBE2";
export const BuiTokenBorderColorSubtle = "#E2E7F0";
export const BuiTokenBorderColorDarkDefault = "#33363D";
export const BuiTokenBorderColorDarkSubtle = "#25272D";
export const BuiTokenBorderWidthDefault = "1px";
export const BuiTokenBorderWidthSubtle = "1px";
export const BuiTokenBorderStyleDefault = "solid";
export const BuiTokenBorderStyleSubtle = "solid";
export const BuiTokenBorderDefault = "1px solid #D3DBE2";
export const BuiTokenBorderSubtle = "1px solid #E2E7F0";
export const BuiTokenBorderDarkDefault = "1px solid #33363D";
export const BuiTokenBorderDarkSubtle = "1px solid #25272D";
export const BuiTokenColorBaseBackground = "#FFFFFF";
export const BuiTokenColorBaseForeground = "#202227";
export const BuiTokenColorBrandPrimary1 = "#001A43";
export const BuiTokenColorBrandPrimary2 = "#00D8D8";
export const BuiTokenColorBrandSecondary1 = "#EF5963";
export const BuiTokenColorBrandSecondary2 = "#FFC26F";
export const BuiTokenColorBrandSecondary3 = "#0763FB";
export const BuiTokenColorWarningBackground = "#FDF3D3";
export const BuiTokenColorWarningForeground = "#854D00";
export const BuiTokenColorDangerBackground = "#FFEEEA";
export const BuiTokenColorDangerForeground = "#B5254C";
export const BuiTokenColorInfoBackground = "#E6F6FF";
export const BuiTokenColorInfoForeground = "#004FD6";
export const BuiTokenColorSuccessBackground = "#DDFDEF";
export const BuiTokenColorSuccessForeground = "#057E4B";
export const BuiTokenColorDefaultBackground = "#F1F4FA";
export const BuiTokenColorDefaultForeground = "#4E555F";
export const BuiTokenColorDarkWarningBackground = "#331400";
export const BuiTokenColorDarkWarningForeground = "#E3C135";
export const BuiTokenColorDarkDangerBackground = "#4D0025";
export const BuiTokenColorDarkDangerForeground = "#FFA08F";
export const BuiTokenColorDarkInfoBackground = "#07153C";
export const BuiTokenColorDarkInfoForeground = "#93C9FB";
export const BuiTokenColorDarkSuccessBackground = "#002918";
export const BuiTokenColorDarkSuccessForeground = "#87D9B6";
export const BuiTokenColorDarkDefaultBackground = "#191B1F";
export const BuiTokenColorDarkDefaultForeground = "#B5BDC5";
export const BuiTokenColorDarkBlue5 = "#020B36";
export const BuiTokenColorDarkBlue10 = "#07153C";
export const BuiTokenColorDarkBlue15 = "#031E49";
export const BuiTokenColorDarkBlue20 = "#05285C";
export const BuiTokenColorDarkBlue25 = "#043C8F";
export const BuiTokenColorDarkBlue30 = "#0D59DE";
export const BuiTokenColorDarkBlue40 = "#377BF1";
export const BuiTokenColorDarkBlue50 = "#509BF7";
export const BuiTokenColorDarkBlue60 = "#63B2F8";
export const BuiTokenColorDarkBlue70 = "#93C9FB";
export const BuiTokenColorDarkBlue80 = "#BDDDF9";
export const BuiTokenColorDarkBlue90 = "#DDF2FE";
export const BuiTokenColorDarkBlue100 = "#FAFDFF";
export const BuiTokenColorDarkGray0 = "#000000";
export const BuiTokenColorDarkGray5 = "#101114";
export const BuiTokenColorDarkGray10 = "#191B1F";
export const BuiTokenColorDarkGray15 = "#25272D";
export const BuiTokenColorDarkGray20 = "#33363D";
export const BuiTokenColorDarkGray25 = "#40444F";
export const BuiTokenColorDarkGray30 = "#545A64";
export const BuiTokenColorDarkGray40 = "#6D727E";
export const BuiTokenColorDarkGray50 = "#8B8F98";
export const BuiTokenColorDarkGray60 = "#9BA3AB";
export const BuiTokenColorDarkGray70 = "#B5BDC5";
export const BuiTokenColorDarkGray80 = "#D1D7DC";
export const BuiTokenColorDarkGray90 = "#E8EAED";
export const BuiTokenColorDarkGray100 = "#FFFFFF";
export const BuiTokenColorDarkIndigo5 = "#080E33";
export const BuiTokenColorDarkIndigo10 = "#0C1850";
export const BuiTokenColorDarkIndigo15 = "#132377";
export const BuiTokenColorDarkIndigo20 = "#1D3098";
export const BuiTokenColorDarkIndigo25 = "#263EBA";
export const BuiTokenColorDarkIndigo30 = "#3952D5";
export const BuiTokenColorDarkIndigo40 = "#5968EE";
export const BuiTokenColorDarkIndigo50 = "#7588F5";
export const BuiTokenColorDarkIndigo60 = "#8E9CF5";
export const BuiTokenColorDarkIndigo70 = "#B0B9FD";
export const BuiTokenColorDarkIndigo80 = "#CDD3FE";
export const BuiTokenColorDarkIndigo90 = "#EBEDFF";
export const BuiTokenColorDarkIndigo100 = "#FAFAFF";
export const BuiTokenColorDarkRed5 = "#2C0216";
export const BuiTokenColorDarkRed10 = "#4D0025";
export const BuiTokenColorDarkRed15 = "#670434";
export const BuiTokenColorDarkRed20 = "#810E3C";
export const BuiTokenColorDarkRed25 = "#9A1841";
export const BuiTokenColorDarkRed30 = "#BC2950";
export const BuiTokenColorDarkRed40 = "#CF4462";
export const BuiTokenColorDarkRed50 = "#EE6368";
export const BuiTokenColorDarkRed60 = "#FE7A71";
export const BuiTokenColorDarkRed70 = "#FFA08F";
export const BuiTokenColorDarkRed80 = "#FFC6B8";
export const BuiTokenColorDarkRed90 = "#FEE3DD";
export const BuiTokenColorDarkRed100 = "#FFF6F5";
export const BuiTokenColorDarkOrange5 = "#2E0600";
export const BuiTokenColorDarkOrange10 = "#420C00";
export const BuiTokenColorDarkOrange15 = "#551507";
export const BuiTokenColorDarkOrange20 = "#732002";
export const BuiTokenColorDarkOrange25 = "#8F2A05";
export const BuiTokenColorDarkOrange30 = "#B43B04";
export const BuiTokenColorDarkOrange40 = "#D45608";
export const BuiTokenColorDarkOrange50 = "#EA7610";
export const BuiTokenColorDarkOrange60 = "#F18A41";
export const BuiTokenColorDarkOrange70 = "#F8AD62";
export const BuiTokenColorDarkOrange80 = "#FCD092";
export const BuiTokenColorDarkOrange90 = "#FDE8CE";
export const BuiTokenColorDarkOrange100 = "#FFFAF5";
export const BuiTokenColorDarkPurple5 = "#150A2E";
export const BuiTokenColorDarkPurple10 = "#211047";
export const BuiTokenColorDarkPurple15 = "#2F195D";
export const BuiTokenColorDarkPurple20 = "#432088";
export const BuiTokenColorDarkPurple25 = "#532BA1";
export const BuiTokenColorDarkPurple30 = "#6E37D2";
export const BuiTokenColorDarkPurple40 = "#8854E3";
export const BuiTokenColorDarkPurple50 = "#A072EE";
export const BuiTokenColorDarkPurple60 = "#B28AF3";
export const BuiTokenColorDarkPurple70 = "#CCACFC";
export const BuiTokenColorDarkPurple80 = "#E0C9FD";
export const BuiTokenColorDarkPurple90 = "#F1E7FE";
export const BuiTokenColorDarkPurple100 = "#FDFAFF";
export const BuiTokenColorDarkYellow5 = "#220C01";
export const BuiTokenColorDarkYellow10 = "#331400";
export const BuiTokenColorDarkYellow15 = "#461F01";
export const BuiTokenColorDarkYellow20 = "#5A2E02";
export const BuiTokenColorDarkYellow25 = "#6F3A02";
export const BuiTokenColorDarkYellow30 = "#875203";
export const BuiTokenColorDarkYellow40 = "#A56F0D";
export const BuiTokenColorDarkYellow50 = "#B78D1F";
export const BuiTokenColorDarkYellow60 = "#C9A32C";
export const BuiTokenColorDarkYellow70 = "#E3C135";
export const BuiTokenColorDarkYellow80 = "#F4DA6C";
export const BuiTokenColorDarkYellow90 = "#FCEFB0";
export const BuiTokenColorDarkYellow100 = "#FFFDF4";
export const BuiTokenColorDarkPink5 = "#23061D";
export const BuiTokenColorDarkPink10 = "#320C2B";
export const BuiTokenColorDarkPink15 = "#4C1042";
export const BuiTokenColorDarkPink20 = "#6B145D";
export const BuiTokenColorDarkPink25 = "#7E1E6F";
export const BuiTokenColorDarkPink30 = "#9F2C8E";
export const BuiTokenColorDarkPink40 = "#BB44AB";
export const BuiTokenColorDarkPink50 = "#CB62BD";
export const BuiTokenColorDarkPink60 = "#E279D6";
export const BuiTokenColorDarkPink70 = "#EF9FE8";
export const BuiTokenColorDarkPink80 = "#F7C0F4";
export const BuiTokenColorDarkPink90 = "#FDE3FD";
export const BuiTokenColorDarkPink100 = "#FAF5FF";
export const BuiTokenColorDarkGreen5 = "#01190F";
export const BuiTokenColorDarkGreen10 = "#002918";
export const BuiTokenColorDarkGreen15 = "#023B22";
export const BuiTokenColorDarkGreen20 = "#025230";
export const BuiTokenColorDarkGreen25 = "#05663A";
export const BuiTokenColorDarkGreen30 = "#058550";
export const BuiTokenColorDarkGreen40 = "#0DAB69";
export const BuiTokenColorDarkGreen50 = "#26C583";
export const BuiTokenColorDarkGreen60 = "#49D097";
export const BuiTokenColorDarkGreen70 = "#87D9B6";
export const BuiTokenColorDarkGreen80 = "#B0E8D1";
export const BuiTokenColorDarkGreen90 = "#D4F7E7";
export const BuiTokenColorDarkGreen100 = "#F5FFFB";
export const BuiTokenColorDarkTeal5 = "#011523";
export const BuiTokenColorDarkTeal10 = "#002338";
export const BuiTokenColorDarkTeal15 = "#01334C";
export const BuiTokenColorDarkTeal20 = "#044762";
export const BuiTokenColorDarkTeal25 = "#005C7A";
export const BuiTokenColorDarkTeal30 = "#057A8F";
export const BuiTokenColorDarkTeal40 = "#179AA6";
export const BuiTokenColorDarkTeal50 = "#13C1CD";
export const BuiTokenColorDarkTeal60 = "#11DFDF";
export const BuiTokenColorDarkTeal70 = "#5CE8EB";
export const BuiTokenColorDarkTeal80 = "#97F1F2";
export const BuiTokenColorDarkTeal90 = "#C9F9FD";
export const BuiTokenColorDarkTeal100 = "#F5FEFF";
export const BuiTokenColorRed5 = "#FFF8F7";
export const BuiTokenColorRed10 = "#FFEEEA";
export const BuiTokenColorRed15 = "#FDDDD5";
export const BuiTokenColorRed20 = "#FFCDC1";
export const BuiTokenColorRed25 = "#FFB9A8";
export const BuiTokenColorRed30 = "#FF9886";
export const BuiTokenColorRed40 = "#FD756A";
export const BuiTokenColorRed50 = "#EF5963";
export const BuiTokenColorRed60 = "#D33A5A";
export const BuiTokenColorRed70 = "#B5254C";
export const BuiTokenColorRed80 = "#8B1439";
export const BuiTokenColorRed90 = "#61002F";
export const BuiTokenColorRed100 = "#260314";
export const BuiTokenColorYellow5 = "#FFFBEF";
export const BuiTokenColorYellow10 = "#FDF3D3";
export const BuiTokenColorYellow15 = "#FBE9B1";
export const BuiTokenColorYellow20 = "#F8DC83";
export const BuiTokenColorYellow25 = "#EFCF61";
export const BuiTokenColorYellow30 = "#E2BA2B";
export const BuiTokenColorYellow40 = "#C99A0D";
export const BuiTokenColorYellow50 = "#B78200";
export const BuiTokenColorYellow60 = "#9F6600";
export const BuiTokenColorYellow70 = "#854D00";
export const BuiTokenColorYellow80 = "#653200";
export const BuiTokenColorYellow90 = "#3D1A00";
export const BuiTokenColorYellow100 = "#1E0A01";
export const BuiTokenColorIndigo5 = "#FAFAFF";
export const BuiTokenColorIndigo10 = "#F0F1FF";
export const BuiTokenColorIndigo15 = "#E0E3FF";
export const BuiTokenColorIndigo20 = "#D1D6FF";
export const BuiTokenColorIndigo25 = "#C4CBFF";
export const BuiTokenColorIndigo30 = "#A5B0FF";
export const BuiTokenColorIndigo40 = "#8192F3";
export const BuiTokenColorIndigo50 = "#697EF5";
export const BuiTokenColorIndigo60 = "#4D65F0";
export const BuiTokenColorIndigo70 = "#314CD8";
export const BuiTokenColorIndigo80 = "#1F36AD";
export const BuiTokenColorIndigo90 = "#111F6A";
export const BuiTokenColorIndigo100 = "#080F33";
export const BuiTokenColorGray0 = "#FFFFFF";
export const BuiTokenColorGray5 = "#F7F9FC";
export const BuiTokenColorGray10 = "#F1F4FA";
export const BuiTokenColorGray15 = "#E2E7F0";
export const BuiTokenColorGray20 = "#D3DBE2";
export const BuiTokenColorGray25 = "#C7D0D9";
export const BuiTokenColorGray30 = "#ACB8C3";
export const BuiTokenColorGray40 = "#8F9BA8";
export const BuiTokenColorGray50 = "#7B8493";
export const BuiTokenColorGray60 = "#666D7C";
export const BuiTokenColorGray70 = "#4E555F";
export const BuiTokenColorGray80 = "#383C45";
export const BuiTokenColorGray90 = "#202227";
export const BuiTokenColorGray100 = "#0E0F10";
export const BuiTokenColorTeal5 = "#F3FEFF";
export const BuiTokenColorTeal10 = "#D8FFFF";
export const BuiTokenColorTeal15 = "#B0FFFF";
export const BuiTokenColorTeal20 = "#88FFFF";
export const BuiTokenColorTeal25 = "#64FCFC";
export const BuiTokenColorTeal30 = "#28F0F0";
export const BuiTokenColorTeal40 = "#00D8D8";
export const BuiTokenColorTeal50 = "#00BCC4";
export const BuiTokenColorTeal60 = "#0597A3";
export const BuiTokenColorTeal70 = "#007589";
export const BuiTokenColorTeal80 = "#00546B";
export const BuiTokenColorTeal90 = "#002B42";
export const BuiTokenColorTeal100 = "#001524";
export const BuiTokenColorOrange5 = "#FFFAF4";
export const BuiTokenColorOrange10 = "#FFEFDE";
export const BuiTokenColorOrange15 = "#FFE2BE";
export const BuiTokenColorOrange20 = "#FFD49A";
export const BuiTokenColorOrange25 = "#FFC26F";
export const BuiTokenColorOrange30 = "#FFA44A";
export const BuiTokenColorOrange40 = "#F48432";
export const BuiTokenColorOrange50 = "#E56B03";
export const BuiTokenColorOrange60 = "#CB4F00";
export const BuiTokenColorOrange70 = "#AF3700";
export const BuiTokenColorOrange80 = "#842301";
export const BuiTokenColorOrange90 = "#511000";
export const BuiTokenColorOrange100 = "#290500";
export const BuiTokenColorGreen5 = "#F5FFFB";
export const BuiTokenColorGreen10 = "#DDFDEF";
export const BuiTokenColorGreen15 = "#C4FAE2";
export const BuiTokenColorGreen20 = "#AFF2D7";
export const BuiTokenColorGreen25 = "#94EBC8";
export const BuiTokenColorGreen30 = "#69DDAB";
export const BuiTokenColorGreen40 = "#31CE8D";
export const BuiTokenColorGreen50 = "#1FBA7A";
export const BuiTokenColorGreen60 = "#06A260";
export const BuiTokenColorGreen70 = "#057E4B";
export const BuiTokenColorGreen80 = "#005C35";
export const BuiTokenColorGreen90 = "#01321D";
export const BuiTokenColorGreen100 = "#001A0E";
export const BuiTokenColorPurple5 = "#FCF8FF";
export const BuiTokenColorPurple10 = "#F6EDFF";
export const BuiTokenColorPurple15 = "#ECDDFF";
export const BuiTokenColorPurple20 = "#E4CEFD";
export const BuiTokenColorPurple25 = "#DABFFD";
export const BuiTokenColorPurple30 = "#C5A0FB";
export const BuiTokenColorPurple40 = "#AA7CF3";
export const BuiTokenColorPurple50 = "#9967EF";
export const BuiTokenColorPurple60 = "#834BE7";
export const BuiTokenColorPurple70 = "#6831CE";
export const BuiTokenColorPurple80 = "#4A2593";
export const BuiTokenColorPurple90 = "#2C145C";
export const BuiTokenColorPurple100 = "#150A2E";
export const BuiTokenColorBlue5 = "#FAFDFF";
export const BuiTokenColorBlue10 = "#E6F6FF";
export const BuiTokenColorBlue15 = "#CEEDFF";
export const BuiTokenColorBlue20 = "#BCE4FF";
export const BuiTokenColorBlue25 = "#A8DAFF";
export const BuiTokenColorBlue30 = "#80C4FF";
export const BuiTokenColorBlue40 = "#4DABFF";
export const BuiTokenColorBlue50 = "#278CFF";
export const BuiTokenColorBlue60 = "#0763FB";
export const BuiTokenColorBlue65 = "#B0CAFF";
export const BuiTokenColorBlue70 = "#004FD6";
export const BuiTokenColorBlue80 = "#002F77";
export const BuiTokenColorBlue90 = "#001A43";
export const BuiTokenColorBlue100 = "#000831";
export const BuiTokenColorPink5 = "#FBF7FF";
export const BuiTokenColorPink10 = "#FFEAFF";
export const BuiTokenColorPink15 = "#FFD3FF";
export const BuiTokenColorPink20 = "#FAC2F9";
export const BuiTokenColorPink25 = "#FAB0F6";
export const BuiTokenColorPink30 = "#EF8FE7";
export const BuiTokenColorPink40 = "#DC6BCF";
export const BuiTokenColorPink50 = "#CD56BD";
export const BuiTokenColorPink60 = "#B140A1";
export const BuiTokenColorPink70 = "#952885";
export const BuiTokenColorPink80 = "#711964";
export const BuiTokenColorPink90 = "#460C3C";
export const BuiTokenColorPink100 = "#25041F";
export const BuiTokenElevationDirectionSunken = "inset";
export const BuiTokenElevationDirectionOverflow = "inset";
export const BuiTokenElevationDirectionDarkSunken = "inset";
export const BuiTokenElevationDirectionDarkOverflow = "inset";
export const BuiTokenElevationXOffsetSunken = "0px";
export const BuiTokenElevationXOffsetDefault = "0px";
export const BuiTokenElevationXOffsetRaised = "0px";
export const BuiTokenElevationXOffsetFloating = "0px";
export const BuiTokenElevationXOffsetOverlay = "0px";
export const BuiTokenElevationXOffsetOverflow = "0px";
export const BuiTokenElevationXOffsetDarkSunken = "0px";
export const BuiTokenElevationXOffsetDarkRaised = "0px";
export const BuiTokenElevationXOffsetDarkFloating = "0px";
export const BuiTokenElevationXOffsetDarkOverlay = "0px";
export const BuiTokenElevationXOffsetDarkOverflow = "0px";
export const BuiTokenElevationYOffsetSunken = "1px";
export const BuiTokenElevationYOffsetDefault = "0px";
export const BuiTokenElevationYOffsetRaised = "1px";
export const BuiTokenElevationYOffsetFloating = "6px";
export const BuiTokenElevationYOffsetOverlay = "24px";
export const BuiTokenElevationYOffsetOverflow = "-60px";
export const BuiTokenElevationYOffsetDarkSunken = "2px";
export const BuiTokenElevationYOffsetDarkRaised = "1px";
export const BuiTokenElevationYOffsetDarkFloating = "6px";
export const BuiTokenElevationYOffsetDarkOverlay = "24px";
export const BuiTokenElevationYOffsetDarkOverflow = "-60px";
export const BuiTokenElevationBlurRadiusSunken = "0px";
export const BuiTokenElevationBlurRadiusDefault = "0px";
export const BuiTokenElevationBlurRadiusRaised = "2px";
export const BuiTokenElevationBlurRadiusFloating = "16px";
export const BuiTokenElevationBlurRadiusOverlay = "48px";
export const BuiTokenElevationBlurRadiusOverflow = "20px";
export const BuiTokenElevationBlurRadiusDarkSunken = "0px";
export const BuiTokenElevationBlurRadiusDarkRaised = "3px";
export const BuiTokenElevationBlurRadiusDarkFloating = "16px";
export const BuiTokenElevationBlurRadiusDarkOverlay = "48px";
export const BuiTokenElevationBlurRadiusDarkOverflow = "20px";
export const BuiTokenElevationSpreadRadiusSunken = "0px";
export const BuiTokenElevationSpreadRadiusDefault = "0px";
export const BuiTokenElevationSpreadRadiusRaised = "0px";
export const BuiTokenElevationSpreadRadiusFloating = "-4px";
export const BuiTokenElevationSpreadRadiusOverlay = "-12px";
export const BuiTokenElevationSpreadRadiusOverflow = "-60px";
export const BuiTokenElevationSpreadRadiusDarkSunken = "0px";
export const BuiTokenElevationSpreadRadiusDarkRaised = "0px";
export const BuiTokenElevationSpreadRadiusDarkFloating = "-4px";
export const BuiTokenElevationSpreadRadiusDarkOverlay = "-12px";
export const BuiTokenElevationSpreadRadiusDarkOverflow = "-60px";
export const BuiTokenElevationColorSunken = "rgba(14, 15, 16, 0.1)";
export const BuiTokenElevationColorDefault = "transparent";
export const BuiTokenElevationColorRaised = "rgba(31, 35, 40, 0.08)";
export const BuiTokenElevationColorFloating = "rgba(37, 41, 46, 0.16)";
export const BuiTokenElevationColorOverlay = "rgba(37, 41, 46, 0.24)";
export const BuiTokenElevationColorOverflow = "rgba(30, 32, 37, 0.1)";
export const BuiTokenElevationColorDarkSunken = "rgba(255, 255, 255, 0.05)";
export const BuiTokenElevationColorDarkRaised = "rgba(1, 4, 9, 0.5)";
export const BuiTokenElevationColorDarkFloating = "rgba(1, 4, 9, 0.5)";
export const BuiTokenElevationColorDarkOverlay = "rgba(1, 4, 9, 0.6)";
export const BuiTokenElevationColorDarkOverflow = "rgba(1, 4, 9, 0.3)";
export const BuiTokenElevationSunken =
  "inset 0px 1px 0px 0px rgba(14, 15, 16, 0.1)";
export const BuiTokenElevationDefault = "0px 0px 0px 0px transparent";
export const BuiTokenElevationRaised = "0px 1px 2px 0px rgba(31, 35, 40, 0.08)";
export const BuiTokenElevationFloating =
  "0px 6px 16px -4px rgba(37, 41, 46, 0.16)";
export const BuiTokenElevationOverlay =
  "0px 24px 48px -12px rgba(37, 41, 46, 0.24)";
export const BuiTokenElevationOverflow =
  "inset 0px -60px 20px -60px rgba(30, 32, 37, 0.1)";
export const BuiTokenElevationDarkSunken =
  "inset 0px 2px 0px 0px rgba(255, 255, 255, 0.05)";
export const BuiTokenElevationDarkRaised = "0px 1px 3px 0px rgba(1, 4, 9, 0.5)";
export const BuiTokenElevationDarkFloating =
  "0px 6px 16px -4px rgba(1, 4, 9, 0.5)";
export const BuiTokenElevationDarkOverlay =
  "0px 24px 48px -12px rgba(1, 4, 9, 0.6)";
export const BuiTokenElevationDarkOverflow =
  "inset 0px -60px 20px -60px rgba(1, 4, 9, 0.3)";
export const BuiTokenFontSizeSm = "12px";
export const BuiTokenFontSizeMd = "14px";
export const BuiTokenFontSizeLg = "16px";
export const BuiTokenFontSizeXl = "20px";
export const BuiTokenFontSize2xl = "24px";
export const BuiTokenFontSize3xl = "30px";
export const BuiTokenFontSize4xl = "34px";
export const BuiTokenFontSize5xl = "42px";
export const BuiTokenFontWeightNormal = "400";
export const BuiTokenFontWeightMedium = "500";
export const BuiTokenFontWeightSemibold = "600";
export const BuiTokenFontWeightBold = "700";
export const BuiTokenFontWeightBlack = "900";
export const BuiTokenFontLineHeightSm = "16px";
export const BuiTokenFontLineHeightMd = "20px";
export const BuiTokenFontLineHeightLg = "24px";
export const BuiTokenFontLineHeightXl = "32px";
export const BuiTokenFontLineHeight2xl = "36px";
export const BuiTokenFontLineHeight3xl = "44px";
export const BuiTokenFontLineHeight4xl = "48px";
export const BuiTokenFontProduct = "'Inter-bds', 'Arial'";
export const BuiTokenFontBrand = "'GTWalsheimPro-bds', 'Arial'";
export const BuiTokenAssetFontInterRegularName = "Inter-bds";
export const BuiTokenAssetFontInterRegularWoff2 =
  "assets/fonts/Inter/Inter-Regular.woff2";
export const BuiTokenAssetFontInterRegularWeight = "400";
export const BuiTokenAssetFontInterRegularStyle = "normal";
export const BuiTokenAssetFontInterMediumName = "Inter-bds";
export const BuiTokenAssetFontInterMediumWoff2 =
  "assets/fonts/Inter/Inter-Medium.woff2";
export const BuiTokenAssetFontInterMediumWeight = "500";
export const BuiTokenAssetFontInterMediumStyle = "normal";
export const BuiTokenAssetFontInterSemiBoldName = "Inter-bds";
export const BuiTokenAssetFontInterSemiBoldWoff2 =
  "assets/fonts/Inter/Inter-SemiBold.woff2";
export const BuiTokenAssetFontInterSemiBoldWeight = "600";
export const BuiTokenAssetFontInterSemiBoldStyle = "normal";
export const BuiTokenAssetFontGtWalsheimBoldName = "GTWalsheimPro-bds";
export const BuiTokenAssetFontGtWalsheimBoldWoff2 =
  "assets/fonts/GTWalsheim/GT-Walsheim-Bold.woff2";
export const BuiTokenAssetFontGtWalsheimBoldWeight = "700";
export const BuiTokenAssetFontGtWalsheimBoldStyle = "normal";
export const BuiTokenAssetFontGtWalsheimBlackName = "GTWalsheimPro-bds";
export const BuiTokenAssetFontGtWalsheimBlackWoff2 =
  "assets/fonts/GTWalsheim/GT-Walsheim-Black.woff2";
export const BuiTokenAssetFontGtWalsheimBlackWeight = "800";
export const BuiTokenAssetFontGtWalsheimBlackStyle = "normal";
export const BuiTokenOpacity0 = "0";
export const BuiTokenOpacity5 = "0.05";
export const BuiTokenOpacity10 = "0.1";
export const BuiTokenOpacity15 = "0.15";
export const BuiTokenOpacity20 = "0.2";
export const BuiTokenOpacity25 = "0.25";
export const BuiTokenOpacity30 = "0.3";
export const BuiTokenOpacity40 = "0.4";
export const BuiTokenOpacity50 = "0.5";
export const BuiTokenOpacity60 = "0.6";
export const BuiTokenOpacity70 = "0.7";
export const BuiTokenOpacity80 = "0.8";
export const BuiTokenOpacity90 = "0.9";
export const BuiTokenOpacity100 = "1.0";
export const BuiTokenRadiusNone = "0";
export const BuiTokenRadiusXs = "2px";
export const BuiTokenRadiusSm = "4px";
export const BuiTokenRadiusMd = "8px";
export const BuiTokenRadiusLg = "12px";
export const BuiTokenRadiusXl = "16px";
export const BuiTokenRadius2xl = "20px";
export const BuiTokenRadiusHalf = "50%";
export const BuiTokenScreenMin = "320px";
export const BuiTokenScreenXs = "480px";
export const BuiTokenScreenSm = "576px";
export const BuiTokenScreenMd = "768px";
export const BuiTokenScreenLg = "992px";
export const BuiTokenScreenXl = "1200px";
export const BuiTokenScreenXxl = "1500px";
export const BuiTokenSpacing0 = "0px";
export const BuiTokenSpacing1 = "4px";
export const BuiTokenSpacing2 = "8px";
export const BuiTokenSpacing3 = "12px";
export const BuiTokenSpacing4 = "16px";
export const BuiTokenSpacing5 = "20px";
export const BuiTokenSpacing6 = "24px";
export const BuiTokenSpacing7 = "28px";
export const BuiTokenSpacing8 = "32px";
export const BuiTokenSpacing9 = "36px";
export const BuiTokenSpacing10 = "40px";
export const BuiTokenSpacing12 = "48px";
export const BuiTokenSpacing16 = "64px";
export const BuiTokenSpacing20 = "80px";
export const BuiTokenSpacing24 = "96px";
export const BuiTokenSpacing25 = "100px";
export const BuiTokenSpacing28 = "112px";
export const BuiTokenSpacing30 = "120px";
export const BuiTokenSpacing32 = "128px";
export const BuiTokenSpacing34 = "136px";
export const BuiTokenSpacing36 = "144px";
export const BuiTokenSpacing37 = "148px";
export const BuiTokenSpacing60 = "240px";
export const BuiTokenSpacing70 = "280px";
export const BuiTokenSpacing90 = "360px";
export const BuiTokenSpacing160 = "640px";
export const BuiTokenSpacing025 = "1px";
export const BuiTokenSpacing05 = "2px";
export const BuiTokenSpacing125 = "5px";
export const BuiTokenSpacing15 = "6px";
export const BuiTokenSpacing65 = "26px";
export const BuiTokenTextNormalSm = "400 12px/16px 'Inter-bds', 'Arial'";
export const BuiTokenTextNormalMd = "400 14px/20px 'Inter-bds', 'Arial'";
export const BuiTokenTextNormalLg = "400 16px/24px 'Inter-bds', 'Arial'";
export const BuiTokenTextDistinctSm = "500 14px/20px 'Inter-bds', 'Arial'";
export const BuiTokenTextDistinctMd = "600 16px/24px 'Inter-bds', 'Arial'";
export const BuiTokenTextDistinctLg = "600 20px/24px 'Inter-bds', 'Arial'";
export const BuiTokenTextHeavySm = "400 24px/32px 'GTWalsheimPro-bds', 'Arial'";
export const BuiTokenTextHeavyMd = "700 30px/36px 'GTWalsheimPro-bds', 'Arial'";
export const BuiTokenTextHeavyLg = "700 34px/44px 'GTWalsheimPro-bds', 'Arial'";
export const BuiTokenTextHeavyXl = "700 42px/48px 'GTWalsheimPro-bds', 'Arial'";
export const BuiTokenZindex0 = "0";
export const BuiTokenZindex1 = "10";
export const BuiTokenZindex2 = "50";
export const BuiTokenZindex3 = "100";
export const BuiTokenZindex4 = "200";
export const BuiTokenZindexMax = "1000";
